<template>
	<fieldset class="fieldset">
		<div class="form-row" v-if="type === 'contract'">
			<field-box name="extra_data[monthly_payment]" :label="$t('forms.monthly_payment')" type="text" :value="data?.extra_data?.monthly_payment" :disabled="disabled"/>
		</div>
		<div class="form-row two-columns">
			<field-box name="extra_data[interest_rate]" :label="$t('forms.interest_rate')" type="text" :value="interestRate" :disabled="disabled"/>
			<field-box name="extra_data[fixation_end]" :label="$t('forms.fixation_end')" type="date" :value="fixationEnd" :disabled="disabled"/>
		</div>
		<div class="form-row two-columns">
			<field-box name="extra_data[extra_payment]" :label="$t('forms.extra_payment')" type="text" :without-key-up="true" event="extra-payment-changed" :value="data?.extra_data?.extra_payment" :disabled="disabled"/>
			<field-box name="extra_data[remaining_amount]" :label="$t('forms.remaining_amount')" type="text" :value="remainingAmount" :disabled="disabled"/>
		</div>
	</fieldset>
</template>

<script>
import FieldBox from "@/components/form-fields/FieldBox.vue";

export default {
	name: "DebtsFieldset",
	props: ['data', 'disabled', 'type', 'edit'],
	data() {
		return {
			remainingAmount: this.data?.extra_data?.remaining_amount != null ? parseFloat(this.data.extra_data.remaining_amount) : null,
			extraPayment: this.data?.extra_data?.extra_payment ? parseFloat(this.data?.extra_data?.extra_payment) : 0,
			interestRate: this.data?.extra_data?.interest_rate || this.data?.data?.urokova_sadzba?.value
		}
	},
	components: {
		FieldBox
	},
	computed: {
		fixationEnd(){
			if (!this.data?.extra_data?.fixation_end) {
				return null;
			}

			const date = this.$moment(this.data.extra_data.fixation_end, 'D.M.Y', true);

			if (!date.isValid()) {
				return null;
			}

			return date.valueOf();
		}
	},
	methods: {
		handleExtraPaymentChange(data){
			if(!this.edit){
				return;
			}

			let value = 0
			if(data.value){
				value = parseFloat(data.value);
			}

			let oldValue = this.extraPayment;
			this.extraPayment = value;

			let newValue = value - oldValue;

			this.remainingAmount = (this.remainingAmount ?? 0) - newValue;
			if(this.remainingAmount < 0){
				this.remainingAmount = 0;
			}

			this.$swal.fire({
				icon: 'info',
				title: this.$t('general.update_remaining_amount_title'),
				text: this.$t('general.update_remaining_amount_text')
			});
		}
	},
	mounted() {
		this.$root.$on('extra-payment-changed', this.handleExtraPaymentChange);
	},
	beforeDestroy() {
		this.$root.$off('extra-payment-changed', this.handleExtraPaymentChange);
	}
}
</script>

<style scoped lang="scss">
fieldset {
	padding: 0;
	margin-inline: 0;
	padding-block: 0;
	padding-inline: 0;
	border: none;
	margin: 0 0 15px;
}


.form-row {
	margin-bottom: 15px;

	&:last-child {
		margin-bottom: 0;
	}

	&.two-columns {
		display: flex;
		justify-content: space-between;
		flex-direction: row;

		.field-box {
			width: calc(50% - 8px);
		}
	}
}

@media($mobileS) {
	.form-row {
		margin-bottom: 10px;

		&.two-columns {
			flex-direction: column;

			.field-box {
				width: 100%;
				margin-bottom: 10px;

				&:last-child {
					margin-bottom: 0;
				}
			}
		}
	}
}
</style>